import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterProcessoGedocPorNumero(numeroprocesso) {
        return axiosJwt.get(`${api}/precontrato/obterprocessogedocpornumero/${numeroprocesso}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterProcessosPorNumeroAta(numeroAta) {
        return axiosJwt.get(`${api}/precontrato/obterprocessosatapornumeroata/${numeroAta}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterFornecedor(cnpjcpf) {
        return axiosJwt.get(`${api}/precontrato/obterfornecedor/${cnpjcpf}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirPreContrato(preContrato) {
        const formData = new FormData();
        formData.append('idContrato', preContrato.idContrato)
        formData.append('vcCodigoEstruturado', preContrato.vcCodigoEstruturado)
        formData.append('tpContratacao', preContrato.tpContratacao)
        formData.append('nuSaldoContrato', preContrato.nuSaldoContrato)
        formData.append('nuValorGlobalContrato', preContrato.nuValorGlobalContrato)
        formData.append('codTipoLicitacao', preContrato.codTipoLicitacao)
        formData.append('dataAutorizacaoMapa', preContrato.dataAutorizacaoMapa)
        formData.append('vcObjetoContrato', preContrato.vcObjetoContrato)
        formData.append('formaAutorizacao', preContrato.formaAutorizacao)
        formData.append('numeroMapa', preContrato.numeroMapa)
        formData.append('codFornecedor', preContrato.codFornecedor)
        formData.append('nomeFornecedor', preContrato.nomeFornecedor)
        formData.append('vcProcessoAditivo', preContrato.vcProcessoAditivo)
        formData.append('itensContrato', preContrato.itensContrato)
        formData.append('numProcessoLicitacao', preContrato.numProcessoLicitacao)
        formData.append('idSituacaoContrato', preContrato.idSituacaoContrato)
        formData.append('usrLoginCadastro', preContrato.usrLoginCadastro)
        formData.append('dataDePublicacaoDoDOE', preContrato.dataDePublicacaoDoDOE)
        formData.append('dataDePublicacaoDoDOU', preContrato.dataDePublicacaoDoDOU)
        formData.append('arquivoAnexoDoDOE', preContrato.arquivoAnexoDoDOE)
        formData.append('arquivoAnexoDoDOU', preContrato.arquivoAnexoDoDOU)
        formData.append('CNO', preContrato.CNO || '')
        formData.append('ART', preContrato.ART || '')

        const usuariosArray = preContrato.usuarios && Array.isArray(preContrato.usuarios) ? preContrato.usuarios : []
        const usuariosIds = usuariosArray.map(usuario => usuario.usuarioId).join(',')
        formData.append('usuarios', usuariosIds)

        return axiosJwt.post(`${api}/precontrato`, formData)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarPreContrato(preContrato) {
        const formData = new FormData()
        formData.append('idContrato', preContrato.idContrato)
        formData.append('vcCodigoEstruturado', preContrato.vcCodigoEstruturado)
        formData.append('tpContratacao', preContrato.tpContratacao)
        formData.append('nuSaldoContrato', preContrato.nuSaldoContrato)
        formData.append('nuValorGlobalContrato', preContrato.nuValorGlobalContrato)
        formData.append('codTipoLicitacao', preContrato.codTipoLicitacao)
        formData.append('dataAutorizacaoMapa', preContrato.dataAutorizacaoMapa)
        formData.append('vcObjetoContrato', preContrato.vcObjetoContrato)
        formData.append('formaAutorizacao', preContrato.formaAutorizacao)
        formData.append('numeroMapa', preContrato.numeroMapa)
        formData.append('codFornecedor', preContrato.codFornecedor)
        formData.append('nomeFornecedor', preContrato.nomeFornecedor)
        formData.append('vcProcessoAditivo', preContrato.vcProcessoAditivo)
        formData.append('itensContrato', preContrato.itensContrato)
        formData.append('numProcessoLicitacao', preContrato.numProcessoLicitacao)
        formData.append('idSituacaoContrato', preContrato.idSituacaoContrato)
        formData.append('usrLoginCadastro', preContrato.usrLoginCadastro)
        formData.append('dataDePublicacaoDoDOE', preContrato.dataDePublicacaoDoDOE)
        formData.append('dataDePublicacaoDoDOU', preContrato.dataDePublicacaoDoDOU)
        formData.append('arquivoAnexoDoDOE', preContrato.arquivoAnexoDoDOE)
        formData.append('arquivoAnexoDoDOU', preContrato.arquivoAnexoDoDOU)
        formData.append('CNO', preContrato.CNO || '')
        formData.append('ART', preContrato.ART || '')
        const usuariosArray = preContrato.usuarios && Array.isArray(preContrato.usuarios) ? preContrato.usuarios : []
        const usuariosIds = usuariosArray.map(usuario => usuario.usuarioId).join(',')
        formData.append('usuarios', usuariosIds)

        return axiosJwt.put(`${api}/precontrato`, formData)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    downloadAnexoDoe(preContrato) {
        return axiosJwt
            .get(`${api}/precontrato/${preContrato.idContrato}/downloaddoe`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadAnexoDou(preContrato) {
        return axiosJwt
            .get(`${api}/precontrato/${preContrato.idContrato}/downloaddou`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterOpcoes() {
        return axiosJwt.get(`${api}/precontrato/opcoes`)
        .then((response) => {
            return response.data
        }).catch((error) => {
            return errorHandler(error)
        })
    },

    obterPorId(contratoId) {
        return axiosJwt.get(`${api}/precontrato/${contratoId}`)
        .then((response) => {
            return response.data
        }).catch((error) => {
            return errorHandler(error)
        })
    },

    obterUsuariosPorContrato(contratoId) {
        return axiosJwt.get(`${api}/precontrato/${contratoId}/usuarios`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirItemContrato(itemContrato) {
        return axiosJwt.post(`${api}/precontrato/inseriritemcontrato`, itemContrato)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarItemContrato(itemContrato) {
        return axiosJwt.put(`${api}/precontrato/atualizaitemcontrato`, itemContrato)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterItensContrato(contratoId) {
        return axiosJwt.get(`${api}/precontrato/obteritenscontrato/${contratoId}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    removerItemContrato(contratoId, itemContratoId) {
        return axiosJwt.delete(`${api}/precontrato/removeritemcontrato/${contratoId}/${itemContratoId}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirSubItemContrato(subIemContrato) {
        return axiosJwt.post(`${api}/precontrato/inserirsubitemcontrato`, subIemContrato)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarSubItemContrato(subIemContrato) {
        return axiosJwt.put(`${api}/precontrato/atualizarsubitemcontrato`, subIemContrato)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    removerSubItemContrato(contratoId, itemContratoId, idItemReferencia) {
        return axiosJwt.delete(`${api}/precontrato/removersubitemcontrato/${contratoId}/${itemContratoId}/${idItemReferencia}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterSubItensContrato(contratoId, itemContratoId) {
        return axiosJwt.get(`${api}/precontrato/obtersubitenscontrato/${contratoId}/${itemContratoId}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    verificarFornecedorLicitacao(numLicitacao, cpfCnpj, idContrato) {
        return axiosJwt
            .get(`${api}/precontrato/verificar-fornecedor-licitacao`, {
                params: { numLicitacao, cpfCnpj, idContrato }
            })
            .then((response) => response.data)
            .catch(() => ({ success: true, data: true }))
    },

    inserirSubItensArquivo(subItem) {
        const formData = new FormData()
        formData.append('idContrato', subItem.idContrato)
        formData.append('idItemReferencia', subItem.idItemReferencia)
        formData.append('arquivo', subItem.arquivo)
        return axiosJwt.post(`${api}/precontrato/inserirsubitensarquivo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    associarUsuarios(codigoContrato, usuarioIds) {
        return axiosJwt.post(`${api}/admin/controleacesso/usuarios/${codigoContrato}/usuarios`, { usuarioIds })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarUsuarios(codigoContrato, usuarioIds) {
        return axiosJwt.patch(`${api}/admin/controleacesso/usuarios/${codigoContrato}/usuarios`, { usuarioIds })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }

}
